import * as z from "zod";
//#region src/__generated__/models/modelsDrawingsController/zod/modelsDrawingCreateDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelsDrawingCreateDtoSchema = z.object({
	name: z.string(),
	page: z.int(),
	pdfId: z.uuid(),
	planXY: z.array(z.int()).optional(),
	projectId: z.uuid(),
	sectionXY: z.array(z.int()).optional(),
	sectionYZ: z.array(z.int()).optional(),
	rotation: z.enum([
		"DEG_0",
		"DEG_90",
		"DEG_180",
		"DEG_270"
	]).describe("Drawing page rotation")
});
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/modelsDrawingDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelsDrawingDtoSchema = z.object({
	areaHeight: z.number().nullish().describe("Height of the selected area in PDF points"),
	areaWidth: z.number().nullish().describe("Width of the selected area in PDF points"),
	author: z.uuid(),
	createdAt: z.iso.datetime().nullish(),
	id: z.uuid(),
	name: z.string(),
	originX: z.number().nullish().describe("X coordinate of the selected area origin in PDF points coordinate system"),
	originY: z.number().nullish().describe("Y coordinate of the selected area origin in PDF points coordinate system"),
	page: z.int(),
	pdfId: z.uuid(),
	planXY: z.array(z.int()).nullish(),
	projectId: z.uuid(),
	sectionXY: z.array(z.int()).nullish(),
	sectionYZ: z.array(z.int()).nullish(),
	rotation: z.enum([
		"DEG_0",
		"DEG_90",
		"DEG_180",
		"DEG_270"
	]).optional().describe("Drawing page rotation")
});
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/create7Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const create7HeaderXUserIdSchema = z.uuid();
const create7Status200Schema = modelsDrawingDtoSchema;
const create7ResponseSchema = create7Status200Schema;
const create7DataSchema = modelsDrawingCreateDtoSchema;
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/deleteSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deletePathDrawingIdSchema = z.uuid();
const deleteStatus200Schema = z.unknown();
const deleteResponseSchema = deleteStatus200Schema;
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/downloadZipPagesSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const downloadZipPagesStatus200Schema = z.array(z.object({
	char: z.string().optional(),
	direct: z.boolean().optional(),
	double: z.number().optional(),
	float: z.number().optional(),
	int: z.int().optional(),
	long: z.int().optional(),
	readOnly: z.boolean().optional(),
	short: z.int().optional()
}));
const downloadZipPagesResponseSchema = downloadZipPagesStatus200Schema;
const downloadZipPagesDataSchema = z.array(z.uuid());
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/modelDrawingPlacementDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelDrawingPlacementDtoSchema = z.object({
	corrections: z.array(z.number()).nullish().describe("Transformation correction parameters used to convert coordinates between drawing and model systems"),
	drawingId: z.uuid(),
	drawingPoints: z.array(z.number()).nullish().describe("Control points defined on the drawing. Coordinates are stored as an array of numeric values"),
	id: z.uuid(),
	modelId: z.uuid(),
	modelPoints: z.array(z.number()).nullish().describe("Corresponding control points in the model coordinate system"),
	status: z.enum([
		"PARAMETERS_NOT_DEFINED",
		"MODEL_POINTS_NOT_DEFINED",
		"READY_FOR_PLACEMENT",
		"PLACED"
	])
});
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/modelsDrawingWithPlacementsDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelsDrawingWithPlacementsDtoSchema = z.object({
	drawing: z.union([modelsDrawingDtoSchema, z.null()]).optional(),
	placements: z.array(modelDrawingPlacementDtoSchema).nullish()
});
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/findByProjectIdSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const findByProjectIdPathProjectIdSchema = z.uuid();
const findByProjectIdStatus200Schema = z.array(modelsDrawingWithPlacementsDtoSchema);
const findByProjectIdResponseSchema = findByProjectIdStatus200Schema;
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/modelsDrawingsToggleDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelsDrawingsToggleDtoSchema = z.object({
	drawingIds: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }),
	modelIds: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" })
});
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/toggleModelDrawingsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const toggleModelDrawingsStatus200Schema = z.unknown();
const toggleModelDrawingsResponseSchema = toggleModelDrawingsStatus200Schema;
const toggleModelDrawingsDataSchema = modelsDrawingsToggleDtoSchema;
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/modelsDrawingUpdateDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelsDrawingUpdateDtoSchema = z.object({
	drawingId: z.uuid().optional(),
	name: z.string().optional(),
	planXY: z.array(z.int()).optional(),
	sectionXY: z.array(z.int()).optional(),
	sectionYZ: z.array(z.int()).optional()
});
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/update4Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const update4Status200Schema = modelsDrawingDtoSchema;
const update4ResponseSchema = update4Status200Schema;
const update4DataSchema = modelsDrawingUpdateDtoSchema;
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/modelsDrawingHighlightAreaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelsDrawingHighlightAreaDtoSchema = z.object({
	areaHeight: z.number().optional(),
	areaWidth: z.number().optional(),
	originX: z.number().optional(),
	originY: z.number().optional(),
	rotation: z.enum([
		"DEG_0",
		"DEG_90",
		"DEG_180",
		"DEG_270"
	]).describe("Drawing page rotation")
});
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/updateHighlightAreaSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updateHighlightAreaPathDrawingIdSchema = z.uuid();
const updateHighlightAreaStatus200Schema = modelsDrawingWithPlacementsDtoSchema;
const updateHighlightAreaResponseSchema = updateHighlightAreaStatus200Schema;
const updateHighlightAreaDataSchema = modelsDrawingHighlightAreaDtoSchema;
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/updatePlacementsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updatePlacementsPathDrawingIdSchema = z.uuid();
const updatePlacementsStatus200Schema = z.array(modelDrawingPlacementDtoSchema);
const updatePlacementsResponseSchema = updatePlacementsStatus200Schema;
const updatePlacementsDataSchema = z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" });
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/modelsDrawingPointsDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelsDrawingPointsDtoSchema = z.object({
	corrections: z.array(z.number()).optional(),
	drawingPoints: z.array(z.number()).optional(),
	modelPoints: z.array(z.number()).optional()
});
//#endregion
//#region src/__generated__/models/modelsDrawingsController/zod/updatePointsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updatePointsPathDrawingIdSchema = z.uuid();
const updatePointsPathModelIdSchema = z.uuid();
const updatePointsStatus200Schema = modelsDrawingWithPlacementsDtoSchema;
const updatePointsResponseSchema = updatePointsStatus200Schema;
const updatePointsDataSchema = modelsDrawingPointsDtoSchema;
//#endregion
export { downloadZipPagesResponseSchema as A, modelsDrawingCreateDtoSchema as B, modelsDrawingsToggleDtoSchema as C, modelsDrawingWithPlacementsDtoSchema as D, findByProjectIdStatus200Schema as E, create7DataSchema as F, create7HeaderXUserIdSchema as I, create7ResponseSchema as L, deletePathDrawingIdSchema as M, deleteResponseSchema as N, modelDrawingPlacementDtoSchema as O, deleteStatus200Schema as P, create7Status200Schema as R, toggleModelDrawingsStatus200Schema as S, findByProjectIdResponseSchema as T, update4ResponseSchema as _, updatePointsStatus200Schema as a, toggleModelDrawingsDataSchema as b, updatePlacementsPathDrawingIdSchema as c, updateHighlightAreaDataSchema as d, updateHighlightAreaPathDrawingIdSchema as f, update4DataSchema as g, modelsDrawingHighlightAreaDtoSchema as h, updatePointsResponseSchema as i, downloadZipPagesStatus200Schema as j, downloadZipPagesDataSchema as k, updatePlacementsResponseSchema as l, updateHighlightAreaStatus200Schema as m, updatePointsPathDrawingIdSchema as n, modelsDrawingPointsDtoSchema as o, updateHighlightAreaResponseSchema as p, updatePointsPathModelIdSchema as r, updatePlacementsDataSchema as s, updatePointsDataSchema as t, updatePlacementsStatus200Schema as u, update4Status200Schema as v, findByProjectIdPathProjectIdSchema as w, toggleModelDrawingsResponseSchema as x, modelsDrawingUpdateDtoSchema as y, modelsDrawingDtoSchema as z };

//# sourceMappingURL=updatePointsSchema.js.map